import React from "react";

/** Libraries */
import { MenuItem, Typography } from "@libraries/mui";

import useTranslation from "@languages/useTranslation";

import { CustomerMessages } from "src/languages/interfaces/customerMessages";

import { NavLink } from "react-router-dom";

/** Hooks */
import { useAuth } from "@hooks/useAuth";

import * as Styled from "./styles";
/** Interfaces */
interface IProps {
  anchorElement: null | HTMLElement;
  onClose: (setting: string) => void;
}

const ProfileMenu: React.FC<IProps> = ({ anchorElement, onClose }) => {
  const { signOut } = useAuth();
  const { t } = useTranslation();

  return (
    <Styled.Container
      sx={{ mt: "45px" }}
      anchorEl={anchorElement}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right"
      }}
      open={Boolean(anchorElement)}
      onClose={onClose}
    >
      <MenuItem>
        <NavLink to="/settings">
          <Typography textAlign="center">
            {t(CustomerMessages.applicationSettings)}
          </Typography>
        </NavLink>
      </MenuItem>
      <MenuItem>
        <Typography textAlign="center" onClick={signOut}>
          {t(CustomerMessages.applicationLogout)}
        </Typography>
      </MenuItem>
    </Styled.Container>
  );
};

export default ProfileMenu;
